const STACK_LIMIT = 100

export default class History {
  constructor(doc) {
    this.doc = doc
    this.undoStack = []
    this.redoStack = []
  }

  execute(command) {
    // Erst auf den Stack, dann anwenden: Doc-Events während apply() sollen
    // bereits canUndo=true sehen (Button-Zustand hängt daran)
    this.undoStack.push(command)
    if (this.undoStack.length > STACK_LIMIT) this.undoStack.shift()
    this.redoStack = []
    command.apply(this.doc)
  }

  undo() {
    const command = this.undoStack.pop()
    if (!command) return false
    command.invert(this.doc)
    this.redoStack.push(command)
    return true
  }

  redo() {
    const command = this.redoStack.pop()
    if (!command) return false
    command.apply(this.doc)
    this.undoStack.push(command)
    return true
  }

  get canUndo() { return this.undoStack.length > 0 }
  get canRedo() { return this.redoStack.length > 0 }
}
